"use client";

import Link from "next/link";
import translations from "@/lib/translations";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import AnimatedText from "@/components/AnimatedText";
import AnimatedLink from "@/components/AnimatedLink";
import AnimatedCarousel from "@/components/AnimatedCarousel";
import AnimatedBlock from "@/components/AnimatedBlock";
import TestimonialCard from "@/components/TestimonialCard";
import { useEffect, useState } from "react";
import Image from "next/image";
import Squircle from "@/components/Squircle";

export default function ProjectPageClient({ project, others, testimonials, lang }) {
	const getCaption = (item) => (item.captionType === "product" ? item.productCaption?.title : item.customCaption);

	const [randomOthers, setRandomOthers] = useState([]);

	useEffect(() => {
		const shuffled = [...others].sort(() => Math.random() - 0.5).slice(0, 3);
		setRandomOthers(shuffled);
	}, [others]);

	return (
		<div className="container project-page">
			<section className="top-project">
				<div className="inner-section padding">
					<div className="row">
						<div className="col-12">
							<AnimatedText variant="bounce">
								<h1 className="title">{project.title}</h1>
							</AnimatedText>
							{project.industry?.title && (
								<AnimatedText variant="fade">
									<p className="industry">{project.industry.title}</p>
								</AnimatedText>
							)}
						</div>
					</div>
					<div className="separator-m"></div>
					<div className="row">
						<div className="col-7">
							<AnimatedText variant="bounce">
								<h4>brief</h4>
							</AnimatedText>
							<AnimatedText variant="fade">
								{project.description?.map((block, i) => (
									<p key={block._key || i}>
										{block.children?.map((span, j) => {
											let content = span.text;
											const marks = span.marks || [];
											return marks.reduce((acc, mark) => {
												if (mark === "strong") return <strong key={j}>{acc}</strong>;
												if (mark === "em") return <em key={j}>{acc}</em>;
												const markDef = block.markDefs?.find((m) => m._key === mark);
												if (markDef?.href)
													return (
														<a key={j} href={markDef.href} target="_blank" rel="noopener noreferrer">
															{acc}
														</a>
													);
												return acc;
											}, content);
										})}
									</p>
								))}
							</AnimatedText>
						</div>
						<div className="col-5">
							{project.expertises?.length > 0 && (
								<div className="expertises">
									<AnimatedText variant="bounce">
										<h4>{translations.role[lang]}</h4>
									</AnimatedText>
									<AnimatedText variant="fade">
										<ul>
											{project.expertises.map((e, i) => (
												<li key={i}>{e.title}</li>
											))}
										</ul>
									</AnimatedText>
									<div className="separator-s"></div>
									<AnimatedText variant="bounce">
										<h4>{translations.products2[lang]}</h4>
									</AnimatedText>
									{project.categories?.length > 0 && (
										<AnimatedText variant="fade">
											<ul>
												{project.categories.map((c, i) => (
													<li key={i}>{c.title}</li>
												))}
											</ul>
										</AnimatedText>
									)}
								</div>
							)}
						</div>
					</div>
				</div>
			</section>
			<section className="project-content">
				<div className="inner-section pt0 pb0">
					<div className="row">
						<div className="col-12">
							{project.content?.map((block, i) => {
								console.log(block._type, block);
								if (block._type === "image") {
									return (
										<div key={i} className={`image ${block.imageRatio && block.imageRatio !== "none" ? `ratio-${block.imageRatio}` : ""}`}>
											{getCaption(block) && (
												<AnimatedText variant="fade">
													<p className="caption">{getCaption(block)}</p>
												</AnimatedText>
											)}
											<AnimatedBlock className="image">
												{block.navbar && block.navbar !== "none" && <Image src={block.navbar === "light" ? "/images/navbar-light.png" : "/images/navbar-dark.png"} alt="navbar" className="navbar" priority width={2460} height={50} />}
												<img src={`${block.asset?.url}?format=webp`} alt="" loading="lazy" />
											</AnimatedBlock>
										</div>
									);
								}

								if (block._type === "imageGrid") {
									return (
										<div key={i} className="image-grid image-grid-4">
											{block.images?.map((img, j) =>
												img.asset?.url ? (
													<div key={j} className="image">
														{getCaption(img) && (
															<AnimatedText variant="fade">
																<p className="caption">{getCaption(img)}</p>
															</AnimatedText>
														)}
														<AnimatedBlock className="image">
															<img src={`${img.asset.url}?format=webp`} alt="" loading="lazy" />
														</AnimatedBlock>
													</div>
												) : null
											)}
										</div>
									);
								}

								if (block._type === "imageGrid2") {
									return (
										<div key={i} className={`image-grid image-grid-${block.ratio} ${block.noSpacing ? " no-spacing" : ""}`}>
											{getCaption(block.images?.[0]) && (
												<AnimatedText variant="fade">
													<p className="caption">{getCaption(block.images[0])}</p>
												</AnimatedText>
											)}
											<div className="sub-container-grid">
												{block.images?.map((img, j) =>
													img.asset?.url ? (
														<div key={j} className="image">
															<AnimatedBlock className="image">
																<img src={`${img.asset.url}?format=webp`} alt="" loading="lazy" />
															</AnimatedBlock>
														</div>
													) : null
												)}
											</div>
										</div>
									);
								}

								if (block._type === "textImage") {
									return (
										<div key={i} className={`text-image ${block.position}`}>
											<div className="image">
												<AnimatedBlock className="image">{block.image?.asset?.url && <img src={`${block.image.asset.url}?format=webp`} alt="" loading="lazy" />}</AnimatedBlock>

												{getCaption(block) && (
													<AnimatedText variant="fade">
														<p className="caption">{getCaption(block)}</p>
													</AnimatedText>
												)}
											</div>
											<div className="text">
												<AnimatedText variant="fade">
													{block.text?.map((b, i) => (
														<p key={b._key || i}>
															{b.children?.map((span, j) => {
																let content = span.text;
																const marks = span.marks || [];
																return marks.reduce((acc, mark) => {
																	if (mark === "strong") return <strong key={j}>{acc}</strong>;
																	if (mark === "em") return <em key={j}>{acc}</em>;
																	const markDef = b.markDefs?.find((m) => m._key === mark);
																	if (markDef?.href)
																		return (
																			<a key={j} href={markDef.href} target="_blank" rel="noopener noreferrer">
																				{acc}
																			</a>
																		);
																	return acc;
																}, content);
															})}
														</p>
													))}
												</AnimatedText>
											</div>
										</div>
									);
								}

								if (block._type === "imageSlider") {
									return (
										<div key={i} className={`image-slider${block.noSpacing ? " no-spacing" : ""}${block.mobileFrame ? " has-frame" : ""}`}>
											{getCaption(block) && (
												<AnimatedText variant="fade">
													<p className="caption">{getCaption(block)}</p>
												</AnimatedText>
											)}
											<AnimatedCarousel>
												<Swiper
													centeredSlides={false}
													centeredSlidesBounds={true}
													breakpoints={{
														900: { slidesPerView: 3, spaceBetween: block.noSpacing ? 0 : 90 },
														600: { slidesPerView: 2, spaceBetween: block.noSpacing ? 0 : 30 },
														0: { slidesPerView: "auto", spaceBetween: block.noSpacing ? 0 : 20 },
													}}
												>
													{block.images?.map((img, j) =>
														img.asset?.url ? (
															<SwiperSlide key={j}>
																<img src={`${img.asset.url}?format=webp`} alt="" loading="lazy" />
																{block.mobileFrame && <Image src="/images/mobile-frame.png" alt="mobile frame" className="mobile-frame" width={750} height={1525} priority={false} />}
															</SwiperSlide>
														) : null
													)}
												</Swiper>
											</AnimatedCarousel>
										</div>
									);
								}

								if (block._type === "textBlock") {
									return (
										<div key={i} className="text-block">
											{block.title && (
												<AnimatedText variant="bounce" className="title">
													<h3>{block.title}</h3>
												</AnimatedText>
											)}
											<div className="sub-text-container">
												<AnimatedText variant="fade">
													{block.text?.map((b, i) => (
														<p key={b._key || i}>
															{b.children?.map((span, j) => {
																let content = span.text;
																const marks = span.marks || [];
																return marks.reduce((acc, mark) => {
																	if (mark === "strong") return <strong key={j}>{acc}</strong>;
																	if (mark === "em") return <em key={j}>{acc}</em>;
																	const markDef = b.markDefs?.find((m) => m._key === mark);
																	if (markDef?.href)
																		return (
																			<a key={j} href={markDef.href} target="_blank" rel="noopener noreferrer">
																				{acc}
																			</a>
																		);
																	return acc;
																}, content);
															})}
														</p>
													))}
												</AnimatedText>
											</div>
										</div>
									);
								}

								if (block._type === "textDouble") {
									return (
										<div key={i} className={`text-block double`}>
											{block.title && (
												<AnimatedText variant="bounce" className="title">
													<h3>{block.title}</h3>
												</AnimatedText>
											)}
											<div className="sub-text-container">
												<AnimatedText variant="fade">
													{block.leftText?.map((b, idx) => (
														<p key={b._key || idx}>
															{b.children?.map((span, j) => {
																let content = span.text;
																const marks = span.marks || [];
																return marks.reduce((acc, mark) => {
																	if (mark === "strong") return <strong key={j}>{acc}</strong>;
																	if (mark === "em") return <em key={j}>{acc}</em>;
																	const markDef = b.markDefs?.find((m) => m._key === mark);
																	if (markDef?.href)
																		return (
																			<a key={j} href={markDef.href} target="_blank" rel="noopener noreferrer">
																				{acc}
																			</a>
																		);
																	return acc;
																}, content);
															})}
														</p>
													))}
												</AnimatedText>
												<AnimatedText variant="fade">
													{block.rightText?.map((b, idx) => (
														<p key={b._key || idx}>
															{b.children?.map((span, j) => {
																let content = span.text;
																const marks = span.marks || [];
																return marks.reduce((acc, mark) => {
																	if (mark === "strong") return <strong key={j}>{acc}</strong>;
																	if (mark === "em") return <em key={j}>{acc}</em>;
																	const markDef = b.markDefs?.find((m) => m._key === mark);
																	if (markDef?.href)
																		return (
																			<a key={j} href={markDef.href} target="_blank" rel="noopener noreferrer">
																				{acc}
																			</a>
																		);
																	return acc;
																}, content);
															})}
														</p>
													))}
												</AnimatedText>
											</div>
										</div>
									);
								}

								if (block._type === "videoBlock") {
									return (
										<div key={i} className={`video-block ${block.columns}`}>
											{getCaption(block) && (
												<AnimatedText variant="fade">
													<p className="caption">{getCaption(block)}</p>
												</AnimatedText>
											)}
											<div className="videos">
												{block.videos?.map((vidItem, j) =>
													vidItem.video?.asset?.url ? (
														<video key={j} controls poster={vidItem.thumbnail?.asset?.url ? `${vidItem.thumbnail.asset.url}?format=webp` : undefined}>
															<source src={vidItem.video.asset.url} />
															Votre navigateur ne supporte pas la vidéo.
														</video>
													) : null
												)}
											</div>
										</div>
									);
								}

								if (block._type === "iframeBlock") {
									return (
										<div key={i} className="iframe-block">
											{block.title && (
												<AnimatedText variant="fade">
													<p className="caption">{block.title}</p>
												</AnimatedText>
											)}
											<AnimatedBlock className="iframe-wrapper">
												<iframe
													src={block.url}
													frameBorder="0"
													allowFullScreen
													title={block.title || `Iframe ${i}`}
												/>
											</AnimatedBlock>
										</div>
									);
								}

								return null;
							})}
						</div>
					</div>
				</div>
			</section>
			{testimonials?.length > 0 && (
				<section className="project-testimonial">
					<div className="inner-section pb0">
						<div className="row">
							<div className="col-12">
								<TestimonialCard testimonial={testimonials[0]} lang={lang} hideProjectLink={true} />
							</div>
						</div>
					</div>
				</section>
			)}
			{((project.credit && ((project.credit.type === "client" && project.credit.client?.title) || (project.credit.type === "custom" && project.credit.custom))) || project.date || project.url) && (
				<section className="project-credits">
					<div className="inner-section padding">
						<div className="row additionnal-info">
							<div className="credits">
								{project.credit && ((project.credit.type === "client" && project.credit.client?.title) || (project.credit.type === "custom" && project.credit.custom)) && (
									<div className="credit">
										<AnimatedText variant="fade" className="title">
											{translations.photoCredit[lang]}
										</AnimatedText>
										<AnimatedText variant="fade">{project.credit.type === "client" ? project.credit.client?.title : project.credit.custom}</AnimatedText>
									</div>
								)}
								{project.date && (
									<div className="date">
										<AnimatedText variant="fade" className="title line">
											{translations.date[lang]}
										</AnimatedText>
										<AnimatedText variant="fade">{project.date.slice(0, 4)}</AnimatedText>
									</div>
								)}
							</div>
							{project.url && (
								<div className="link">
									<AnimatedText variant="fade">
										<a href={project.url} target="_blank">
											{translations.viewWebsite[lang]}
										</a>
									</AnimatedText>
								</div>
							)}
						</div>
					</div>
				</section>
			)}
			{others?.length > 0 && (
				<section className="related-projects">
					<div className="inner-section">
						<div className="row">
							<div className="col-12 image-slider">
								<AnimatedText variant="bounce">
									<h2 className="center">
										<span className="sub-text">{translations.other[lang]}</span>
										{translations.work[lang]}
									</h2>
								</AnimatedText>
								<div className="separator-m"></div>
								<AnimatedCarousel>
									<Swiper
										centeredSlides={false}
										centeredSlidesBounds={true}
										breakpoints={{
											900: { slidesPerView: 3, spaceBetween: 30 },
											600: { slidesPerView: 2, spaceBetween: 30 },
											0: { slidesPerView: "auto", spaceBetween: 20 },
										}}
									>
										{randomOthers.map((p) => (
											<SwiperSlide key={p._id}>
												<AnimatedLink key={p._id} href={`/${lang}/work/${p.slug_shared}`}>
													<article className="project">
														<Squircle size="card"></Squircle>
														<div className="thumbnail">
															<Squircle size="inner-card"></Squircle>
															{p.thumbnail && <img src={`${p.thumbnail.asset.url}?format=webp`} alt="" className="thumb" loading="lazy" />}
														</div>
														<div className="infos">
															<AnimatedText variant="bounce">
																<h3 className="title">{p.title}</h3>
															</AnimatedText>
															<AnimatedText variant="fade">
																<ul className="meta">
																	{p.categories?.map((c, i) => (
																		<li key={i}>{c.title}</li>
																	))}
																</ul>
															</AnimatedText>
														</div>
													</article>
												</AnimatedLink>
											</SwiperSlide>
										))}
									</Swiper>
								</AnimatedCarousel>
								<div className="separator-m"></div>
								<AnimatedText variant="fade" className="center">
									<AnimatedLink href={`/${lang}/work`}>{translations.allProjects[lang]}</AnimatedLink>
								</AnimatedText>
							</div>
						</div>
					</div>
				</section>
			)}
		</div>
	);
}
